module.exports = __webpack_public_path__ + "files/a5b54659e8c66beaad9b40c854e52262.png";